import styled from '@emotion/styled';
import { PlayerMicCheck } from '~/modules/Elements/VolumeIndicator';
import PlayersManager from '~/modules/Players/PlayersManager';

interface Props {
  names?: string[];
  variant?: 'default' | 'mobilePreview' | 'desktopPreview';
}

function MicCheck({ names, variant = 'default' }: Props) {
  return (
    <MicCheckContainer data-variant={variant}>
      {PlayersManager.getPlayers().map((player) => (
        <Indicator data-variant={variant} data-test={`mic-check-p${player.number}`} key={player.number}>
          <MicBarSlot data-variant={variant}>
            <PlayerMicCheck playerNumber={player.number} variant={variant === 'desktopPreview' ? 'default' : variant} />
          </MicBarSlot>

          <PlayerName data-variant={variant} className="ph-no-capture">
            {names?.[player.number] ?? player.getName()}
          </PlayerName>
        </Indicator>
      ))}
    </MicCheckContainer>
  );
}

const MicCheckContainer = styled.div`
  display: flex;
  gap: 1.25rem;
  align-items: stretch;
  width: 100%;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 0.75rem;
  }

  > div {
    flex: 1;
    min-width: 0;
  }

  /* ✅ desktopPreview: centrado + wrap para 3-4 players */
  &[data-variant='desktopPreview'] {
    justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;
  }
`;

const MicBarSlot = styled.div`
  position: relative;
  width: 100%;
  border-radius: 999px;

  background: var(--walky-canvas);
  outline: 1px solid var(--walky-border);
  overflow: hidden;

  height: 10px;
  margin: 0.35rem auto 0.8rem auto;

  &[data-variant='mobilePreview'] {
    height: 22px;
    margin: 0.5rem auto 1rem auto;
  }

  &[data-variant='desktopPreview'] {
    height: 16px;
    margin: 0.5rem auto 0.75rem auto;
  }
`;

const PlayerName = styled.span`
  display: block;
  text-align: center;
  font-weight: 700;
  line-height: 1.1;

  &[data-variant='mobilePreview'] {
    font-size: clamp(16px, 4.8vw, 22px);
  }

  &[data-variant='desktopPreview'] {
    font-size: clamp(16px, 1.2vw, 22px);
  }
`;

const Indicator = styled.div`
  position: relative;
  border: 1px solid var(--walky-border);
  padding: 1rem 1.25rem;
  background: var(--walky-surface-raised);
  backdrop-filter: blur(10px);

  text-align: center;
  color: var(--walky-ink);
  border-radius: 8px;

  @media (max-width: 640px) {
    font-size: 1.4rem;
    padding: 0.85rem 1rem;
  }

  &[data-variant='mobilePreview'] {
    @media (max-width: 640px) {
      font-size: clamp(16px, 4.6vw, 20px);
      padding: 1.05rem 1.05rem;
      border-radius: 14px;
    }
  }

  &[data-variant='desktopPreview'] {
    padding: 1.1rem 1.4rem;
    border-radius: 16px;

    /* ✅ 2 columnas “naturales” si hay muchos */
    flex: 0 1 360px;
    max-width: min(420px, 45vw);
  }
`;

export default MicCheck;
